import { render } from "./Auto24.vue?vue&type=template&id=5cc53656&scoped=true"
import script from "./Auto24.vue?vue&type=script&lang=js"
export * from "./Auto24.vue?vue&type=script&lang=js"

import "./Auto24.vue?vue&type=style&index=0&id=5cc53656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc53656"]])

export default __exports__